module.exports = __webpack_public_path__ + "img/work-in-progress.a69439e2.png";